<template>
  <ul class="linear-info mb-3">
    <li>
      <label for="mi" id="label-mi">
        <img src="./../../assets/opc-mi.png" alt="" width="75%" />
        <span>
          <input
            v-model="inputValue"
            @change="updateInput('change', inputValue, 'label-mi')"
            type="radio"
            name="planPara"
            id="mi"
            value="individual"
          />
        </span>
      </label>
    </li>
    <li>
      <label for="mi-pareja" id="label-mi-pareja">
        <img src="./../../assets/opc-mi-pareja.png" width="75%" alt="" />
        <span>
          <input
            v-model="inputValue"
            @change="updateInput('change', inputValue, 'label-mi-pareja')"
            type="radio"
            name="planPara"
            id="mi-pareja"
            value="dos"
          />
        </span>
      </label>
    </li>
    <li>
      <label for="mi-pareja-hijo" id="label-mi-pareja-hijo">
        <img src="./../../assets/opc-mi-pareja-hijo.png" width="75%" alt="" />
        <span>
          <input
            v-model="inputValue"
            @change="updateInput('change', inputValue, 'label-mi-pareja-hijo')"
            type="radio"
            name="planPara"
            value="opc-my-partner-son"
            id="mi-pareja-hijo"
          />
        </span>
      </label>
    </li>
    <li>
      <label for="mi-hijo" id="label-mi-hijo">
        <img src="./../../assets/opc-mi-hijo.png" width="75%" />
        <span>
          <input
            v-model="inputValue"
            @change="updateInput('change', inputValue, 'label-mi-hijo')"
            type="radio"
            name="planPara"
            value="opc-my-son" dos
            id="mi-hijo"
          />
        </span>
      </label>
    </li>
  </ul>
</template>
<script>
const labelInputs = [
  "label-mi",
  "label-mi-pareja",
  "label-mi-pareja-hijo",
  "label-mi-hijo",
];
export default {
  name: "PlanFor",
  data() {
    return { inputValue: "" };
  },
  methods: {
    updateInput(type, value, labelId) {
      // remove actives
      for (let i = 0; i < labelInputs.length; i++) {
        document.getElementById(labelInputs[i]).classList.remove("active");
      }
      document.getElementById(labelId).classList.add("active");
      // window.scroll(0, document.body.scrollHeight);
      return this.$emit(type, value);
    },
  },
};
</script>
<style scoped>
.linear-info {
  padding: 0;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: auto auto auto auto;
  justify-content: space-around;
  width: 100%;
  max-width: 90%;
  margin: 10px auto;
}
.linear-info li {
  text-align: center;
  display: grid;
}

.linear-info img {
  display: block;
}
.linear-info img {
  border: 2px solid darkgray;
  border-radius: 50%;
}
.linear-info label.active img {
  border: 2px solid #fbaf33;
  border-radius: 50%;
}
input {
  display: none;
}
@media screen and (max-width: 480px) {
  .linear-info {
    grid-template-columns: auto auto;
    grid-gap: 10px;
    overflow: scroll;
  }
  .linear-info img {
    /* width: 100%; */
    margin: 0 auto;
  }
}
</style>
